import React from 'react';

import { Box } from '@mui/material';
import { UserAccountDetailsForm } from '../UserAccountDetailsForm';
import { DetailsViewEditButton } from '../DetailsViewEditButton';

export type UserAccountDetailsProps = {
    civilite?: number | null;
    prenom?: string;
    nom?: string;
    email?: string;
    telephone?: string;
    manageAvatar?: React.ReactNode;
};

export const UserAccountDetails: React.FunctionComponent<UserAccountDetailsProps> = function ({
    civilite,
    prenom,
    nom,
    email,
    telephone,
    manageAvatar,
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: 4,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        gap: 4,
                    }}
                >
                    {manageAvatar || null}
                    <Box>
                        <UserAccountDetailsForm
                            civilite={civilite}
                            prenom={prenom}
                            nom={nom}
                            email={email}
                            telephone={telephone}
                        />
                    </Box>
                </Box>
                <DetailsViewEditButton
                    label="Demander la modification de mes informations"
                    href="https://www.legal2digital.fr/contactez-nous/?origine=13&demande=infos"
                    openInNewTab
                />
            </Box>
        </Box>
    );
};
